import { WikiLayout } from "@/components/WikiLayout";
import { WikiPage } from "@/components/WikiPage";

const EmergencyContacts = () => {
  return (
    <WikiLayout>
      <WikiPage 
        title="Emergency Contacts" 
        description="Important phone numbers and contact information"
      >
        <section className="space-y-6">
          <div className="bg-destructive/10 border border-destructive/30 rounded-lg p-4">
            <p className="font-semibold text-destructive mb-2">🚨 Life-Threatening Emergency: Call 911</p>
            <p className="text-muted-foreground text-sm">
              For medical emergencies, fire, or serious accidents, always call 911 first, then notify BlueLux management.
        </p>
      </div>

      <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Company Information</h2>
      <div className="border border-border rounded-lg p-4 mb-6">
        <div className="space-y-1 text-muted-foreground">
          <p><strong>Company:</strong> Blue Lux LLC</p>
          <p><strong>Registered Address:</strong> 14044 Rancho Santa Fe Lakes Dr., Rancho Santa Fe, CA 92067</p>
          <p><strong>Mailing Address:</strong> P.O. Box 8831, Rancho Santa Fe, CA 92067</p>
        </div>
      </div>

      <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">BlueLux Management</h2>
          <div className="space-y-4">
          <div className="border border-border rounded-lg p-4">
            <h3 className="text-lg font-medium mb-2">Main Office</h3>
            <div className="space-y-1 text-muted-foreground">
              <p><strong>Phone:</strong> (601) 258-3589</p>
              <p><strong>Email:</strong> team@bluelux.com</p>
              <p><strong>Hours:</strong> Monday-Friday 8:00 AM - 5:00 PM</p>
            </div>
          </div>

          <div className="border border-border rounded-lg p-4">
            <h3 className="text-lg font-medium mb-2">Manager - Sam Daoud</h3>
            <div className="space-y-1 text-muted-foreground">
              <p><strong>Cell:</strong> (619) 999-5199</p>
              <p><strong>Email:</strong> sam@bluelux.com</p>
              <p><strong>Best for:</strong> Route issues, customer concerns, scheduling</p>
            </div>
          </div>

          <div className="border border-border rounded-lg p-4">
            <h3 className="text-lg font-medium mb-2">After-Hours Emergency Line</h3>
            <div className="space-y-1 text-muted-foreground">
              <p><strong>Phone:</strong> (619) 999-5199</p>
              <p><strong>Available:</strong> 24/7 for emergencies only</p>
              <p className="text-sm italic">Use only for accidents, injuries, major property damage, or situations requiring immediate attention</p>
            </div>
          </div>
          </div>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Medical & Safety</h2>
          <div className="space-y-4">
            <div className="border border-border rounded-lg p-4">
              <h3 className="text-lg font-medium mb-2">Emergency Services</h3>
              <div className="space-y-1 text-muted-foreground">
                <p><strong>Emergency:</strong> 911</p>
                <p><strong>Poison Control:</strong> 1-800-222-1222</p>
                <p><strong>Non-Emergency Police:</strong> (619) 531-2000</p>
            </div>
          </div>

          <div className="border border-border rounded-lg p-4">
              <h3 className="text-lg font-medium mb-2">Contractor Insurance & Liability</h3>
              <div className="space-y-1 text-muted-foreground">
                <p><strong>Note:</strong> As an independent contractor, you're responsible for your own health insurance</p>
                <p className="text-sm">BlueLux carries general liability insurance that covers property damage and accidents occurring during service</p>
                <p className="text-sm">For work-related injuries, contact BlueLux management immediately to file incident report</p>
              </div>
            </div>
          </div>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Vendors & Services</h2>
          <div className="space-y-4">
          <div className="border border-border rounded-lg p-4">
            <h3 className="text-lg font-medium mb-2">Chemical Supplier</h3>
            <div className="space-y-1 text-muted-foreground">
              <p><strong>Company:</strong> SCP Distributors LLC</p>
              <p><strong>Phone:</strong> +1 (858) 467-9495</p>
              <p><strong>Use for:</strong> Emergency chemical needs or technical questions</p>
            </div>
          </div>

          <div className="border border-border rounded-lg p-4">
            <h3 className="text-lg font-medium mb-2">Equipment Parts</h3>
            <div className="space-y-1 text-muted-foreground">
              <p><strong>Company:</strong> SCP Distributors LLC</p>
              <p><strong>Phone:</strong> +1 (858) 467-9495</p>
            </div>
          </div>
          </div>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Utility Companies</h2>
          <div className="space-y-4">
            <div className="border border-border rounded-lg p-4">
              <h3 className="text-lg font-medium mb-2">SDG&E (Electricity)</h3>
              <div className="space-y-1 text-muted-foreground">
                <p><strong>Customer Service:</strong> 1-800-411-7343</p>
                <p><strong>Gas Leak Emergency:</strong> 1-800-611-7343</p>
                <p><strong>Power Outage Reporting:</strong> 1-800-411-7343</p>
              </div>
            </div>

            <div className="border border-border rounded-lg p-4">
              <h3 className="text-lg font-medium mb-2">City of San Diego Water Dept</h3>
              <div className="space-y-1 text-muted-foreground">
                <p><strong>Customer Service:</strong> (619) 515-3500</p>
                <p><strong>Water Emergency:</strong> (619) 515-3525</p>
              </div>
          </div>
        </div>

        <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Roadside Assistance</h2>
          <div className="border border-border rounded-lg p-4">
            <div className="space-y-2 text-muted-foreground">
              <p><strong>Your personal auto insurance roadside assistance</strong></p>
              <p className="text-sm">If you have flat tire, dead battery, or need tow:</p>
              <ul className="list-disc list-inside ml-4 space-y-1 text-sm">
                <li>Call your insurance provider's roadside number</li>
                <li>Notify BlueLux office that you're delayed</li>
                <li>Time spent waiting may be compensated—document with receipts</li>
              </ul>
            </div>
          </div>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">When to Use Which Contact</h2>
          <div className="space-y-4">
            <div className="bg-muted/50 p-4 rounded-lg">
              <h3 className="text-sm font-medium mb-2">Call 911 for:</h3>
              <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground ml-4">
                <li>Any injury requiring medical attention</li>
                <li>Vehicle accidents</li>
                <li>Fire or gas leaks</li>
                <li>Dangerous situations</li>
              </ul>
            </div>

            <div className="bg-muted/50 p-4 rounded-lg">
              <h3 className="text-sm font-medium mb-2">Call Office for:</h3>
              <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground ml-4">
                <li>Route questions or running late</li>
                <li>Customer complaints or concerns</li>
                <li>Equipment failures</li>
                <li>Chemical or supply needs</li>
                <li>Schedule changes</li>
              </ul>
            </div>

            <div className="bg-muted/50 p-4 rounded-lg">
              <h3 className="text-sm font-medium mb-2">Call After-Hours Line for:</h3>
              <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground ml-4">
                <li>Accidents or injuries (after calling 911)</li>
                <li>Major property damage</li>
                <li>Vehicle breakdowns preventing route completion</li>
                <li>Urgent safety concerns</li>
              </ul>
            </div>
          </div>

          <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mt-8">
            <p className="text-sm text-muted-foreground">
              💡 <strong>Pro Tip:</strong> Save these key numbers in your phone now, before you need them!
            </p>
          </div>
        </section>
      </WikiPage>
    </WikiLayout>
  );
};

export default EmergencyContacts;